import { jsx as i, jsxs as f, Fragment as D } from "react/jsx-runtime";
import { createContext as K, useEffect as C, useContext as $, useCallback as we, forwardRef as x, useRef as J, useState as j, useImperativeHandle as Q } from "react";
function Ae(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Ce = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var n = {}.hasOwnProperty;
    function t() {
      for (var o = "", r = 0; r < arguments.length; r++) {
        var l = arguments[r];
        l && (o = a(o, s(l)));
      }
      return o;
    }
    function s(o) {
      if (typeof o == "string" || typeof o == "number")
        return o;
      if (typeof o != "object")
        return "";
      if (Array.isArray(o))
        return t.apply(null, o);
      if (o.toString !== Object.prototype.toString && !o.toString.toString().includes("[native code]"))
        return o.toString();
      var r = "";
      for (var l in o)
        n.call(o, l) && o[l] && (r = a(r, l));
      return r;
    }
    function a(o, r) {
      return r ? o ? o + " " + r : o + r : o;
    }
    e.exports ? (t.default = t, e.exports = t) : window.classNames = t;
  })();
})(Ce);
var De = Ce.exports;
const k = /* @__PURE__ */ Ae(De), ze = "@gjensidige/core-analytics", Ze = "16.0.8", B = "not-set", xe = {
  application_module: B,
  application_name: B,
  business_area: B,
  customer_segment: B,
  event_source: ze,
  event_version: Ze
}, Le = (e, n, t) => je({ ...e, ...n }, "link", t), he = K({
  options: { ...xe }
}), Be = ({ options: e, ...n }) => /* @__PURE__ */ i(he.Provider, { value: { options: e }, ...n });
let me = 0;
function je(e = {}, n, t) {
  var s;
  const a = (s = window.utag) == null ? void 0 : s[n].bind(window.utag);
  a ? t ? a(ve(e), t) : a(ve(e)) : me < 10 ? setTimeout(() => je(e, n), 100, me++) : console.error(`window.utag.${n} not found `, e);
}
function ve(e) {
  const n = { ...xe };
  return Object.entries(e).forEach(([t, s]) => {
    const a = t === "eventLabel" || t === "eventStatus", o = t.replace(/[A-Z]/g, "_$&").toLowerCase();
    a && (s = `${s || ""}`.toLowerCase().split(" ").join("-")), n[o] = s;
  }), {
    ...n,
    event_module: e.event_module || n.application_module,
    page_pathname: e.page_pathname || Oe(n),
    measure_source: n.event_source,
    measure_version: n.event_version
  };
}
function Oe(e) {
  return `${window.location.pathname.replace(/\/$/, "")}/${e.application_name}/${e.application_module}/${e.scenario_name}/${e.scenario_step}`.replace(/\/(undefined|null|not-set)/g, "").replace("/Din+side/", "/Din-side/");
}
const Ve = (e) => /* @__PURE__ */ f("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", "aria-hidden": !0, focusable: !1, ...e, children: [
  /* @__PURE__ */ i("path", { d: "M11.9982 8.33522V13.763M2.21741 18.2436L10.3179 3.00789C10.4797 2.70363 10.7218 2.44901 11.0182 2.27143C11.3146 2.09384 11.654 2 12 2C12.346 2 12.6854 2.09384 12.9818 2.27143C13.2782 2.44901 13.5203 2.70363 13.6821 3.00789L21.7826 18.2436C21.9346 18.5311 22.0092 18.8529 21.9991 19.1776C21.989 19.5023 21.8945 19.8189 21.7248 20.0965C21.5551 20.3741 21.3161 20.6032 21.0309 20.7615C20.7458 20.9199 20.4243 21.002 20.0977 21H3.89861C3.57238 21.0014 3.25133 20.9188 2.9667 20.7602C2.68206 20.6016 2.44351 20.3724 2.27427 20.0949C2.10503 19.8175 2.01085 19.5011 2.00088 19.1767C1.99092 18.8523 2.06551 18.5308 2.21741 18.2436Z", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ i("path", { d: "M12 18C12.5523 18 13 17.5523 13 17C13 16.4477 12.5523 16 12 16C11.4477 16 11 16.4477 11 17C11 17.5523 11.4477 18 12 18Z", fill: "currentColor" })
] }), Pe = (e) => /* @__PURE__ */ f("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", "aria-hidden": !0, focusable: !1, ...e, children: [
  /* @__PURE__ */ i("path", { d: "M6 23H1V12H6", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ i("path", { d: "M6 12L9 1C9.79565 1 10.5587 1.31607 11.1213 1.87868C11.6839 2.44129 12 3.20435 12 4V10H19.5C19.9325 10 20.3599 10.0936 20.7529 10.2742C21.1459 10.4549 21.4951 10.7183 21.7767 11.0466C22.0584 11.3749 22.2657 11.7601 22.3845 12.176C22.5033 12.5919 22.5307 13.0285 22.465 13.456L21.388 20.456C21.2792 21.1638 20.9207 21.8093 20.3775 22.2758C19.8343 22.7424 19.1421 22.9993 18.426 23H6V12Z", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" })
] }), Re = (e) => /* @__PURE__ */ i("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", "aria-hidden": !0, focusable: !1, ...e, children: /* @__PURE__ */ i("path", { d: "M4.6671 4.66656H20.6671L18.0004 11.3332H4.6671M4.6671 4.66656L2 2M4.6671 4.66656V11.3332M4.6671 11.3332L2 15.3333H22M7.33355 20.0002C7.33355 21.1047 6.43812 22.0002 5.33355 22.0002C4.22898 22.0002 3.33355 21.1047 3.33355 20.0002C3.33355 18.8956 4.22898 18.0002 5.33355 18.0002C6.43812 18.0002 7.33355 18.8956 7.33355 20.0002ZM20.6669 20.0002C20.6669 21.1047 19.7715 22.0002 18.6669 22.0002C17.5623 22.0002 16.6669 21.1047 16.6669 20.0002C16.6669 18.8956 17.5623 18.0002 18.6669 18.0002C19.7715 18.0002 20.6669 18.8956 20.6669 20.0002Z", stroke: "currentColor", strokeWidth: 2, strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" }) }), $e = (e) => /* @__PURE__ */ i("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", "aria-hidden": !0, focusable: !1, ...e, children: /* @__PURE__ */ i("path", { d: "M22 22L15.656 15.656M18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10Z", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }) }), He = (e) => /* @__PURE__ */ f("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", "aria-hidden": !0, focusable: !1, ...e, children: [
  /* @__PURE__ */ i("path", { d: "M12 9.56757C14.0538 9.56757 15.7188 7.87351 15.7188 5.78378C15.7188 3.69406 14.0538 2 12 2C9.94619 2 8.28125 3.69406 8.28125 5.78378C8.28125 7.87351 9.94619 9.56757 12 9.56757Z", stroke: "currentColor", strokeWidth: 2, strokeMiterlimit: 10, strokeLinecap: "square", strokeLinejoin: "round" }),
  /* @__PURE__ */ i("path", { d: "M12 13.8919C8.5211 13.8919 6.49231 15.7121 5.625 16.5946C4.75769 17.4771 3.5 19.4195 3.5 22H20.5C20.5 19.4195 19.4375 17.6757 18.375 16.5946C17.2441 15.444 15.4789 13.8919 12 13.8919Z", stroke: "currentColor", strokeWidth: 2, strokeMiterlimit: 10, strokeLinecap: "square", strokeLinejoin: "round" })
] }), We = (e) => /* @__PURE__ */ i("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", "aria-hidden": !0, focusable: !1, ...e, children: /* @__PURE__ */ i("path", { d: "M12 11.2053V15.978M12 7.625V7.66875M22.5 12C22.5 17.799 17.799 22.5 12 22.5C6.20101 22.5 1.5 17.799 1.5 12C1.5 6.20101 6.20101 1.5 12 1.5C17.799 1.5 22.5 6.20101 22.5 12Z", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }) }), Fe = (e) => /* @__PURE__ */ f("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", "aria-hidden": !0, focusable: !1, ...e, children: [
  /* @__PURE__ */ i("path", { d: "M16.556 1H7.444L1 7.444V16.556L7.444 23H16.556L23 16.556V7.444L16.556 1Z", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ i("path", { d: "M12 7V13", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ i("path", { d: "M12 18C12.5523 18 13 17.5523 13 17C13 16.4477 12.5523 16 12 16C11.4477 16 11 16.4477 11 17C11 17.5523 11.4477 18 12 18Z", fill: "currentColor" })
] }), qe = (e) => /* @__PURE__ */ f("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", "aria-hidden": !0, focusable: !1, ...e, children: [
  /* @__PURE__ */ i("path", { d: "M14.3281 4.67188L19.3281 9.67188", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ i("path", { d: "M8 20.9996L2 21.9996L3 15.9996L16.414 2.58557C16.7891 2.21063 17.2977 2 17.828 2C18.3583 2 18.8669 2.21063 19.242 2.58557L21.414 4.75757C21.7889 5.13263 21.9996 5.64124 21.9996 6.17157C21.9996 6.7019 21.7889 7.21052 21.414 7.58557L8 20.9996Z", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" })
] }), Se = (e) => /* @__PURE__ */ f("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", "aria-hidden": !0, focusable: !1, ...e, children: [
  /* @__PURE__ */ i("path", { d: "M19 19L5 5", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ i("path", { d: "M5 19L19 5", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" })
] }), Ue = (e) => /* @__PURE__ */ i("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", "aria-hidden": !0, focusable: !1, ...e, children: /* @__PURE__ */ i("path", { d: "M3 8L12 17L21 8", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }) }), ue = (e) => /* @__PURE__ */ i("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", "aria-hidden": !0, focusable: !1, ...e, children: /* @__PURE__ */ i("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M4 12h15.5m0 0-7-7m7 7-7 7" }) }), Ge = "_nav_y272t_37", Ke = "_isLoggedIn_y272t_54", Je = "_item_y272t_62", Qe = "_chevron_y272t_95", Xe = "_expand_y272t_98", Ye = "_cta_y272t_135", et = "_badge_y272t_138", tt = "_burger_y272t_149", nt = "_skip_y272t_208", ot = "_truncate_y272t_228", st = "_logo_y272t_239", rt = "_search_y272t_295", it = "_user_y272t_325", at = "_actions_y272t_331", ct = "_cart_y272t_347", lt = "_cms_y272t_370", dt = "_desktopThirdLevel_y272t_422", ut = "_space_y272t_461", gt = "_systemMessages_y272t_504", p = {
  nav: Ge,
  isLoggedIn: Ke,
  item: Je,
  chevron: Qe,
  expand: Xe,
  "item-fade": "_item-fade_y272t_1",
  cta: Ye,
  badge: et,
  burger: tt,
  skip: nt,
  truncate: ot,
  logo: st,
  search: rt,
  user: it,
  actions: at,
  cart: ct,
  cms: lt,
  break: "_break_y272t_409",
  desktopThirdLevel: dt,
  space: ut,
  systemMessages: gt
}, pt = "_helpText_101f0_1", ht = "_toggle_101f0_6", ft = "_text_101f0_22", mt = "_isBoolean_101f0_29", vt = {
  helpText: pt,
  toggle: ht,
  text: ft,
  isBoolean: mt
}, _t = "_inputGroup_1k7bp_1", kt = "_column_1k7bp_20", bt = "_message_1k7bp_32", yt = "_validation_1k7bp_1", wt = "_ok_1k7bp_66", Ct = {
  inputGroup: _t,
  column: kt,
  "column-background": "_column-background_1k7bp_21",
  "row-background": "_row-background_1k7bp_26",
  message: bt,
  validation: yt,
  ok: wt
}, xt = "@gjensidige/builders-components", Lt = "1.0.0", jt = typeof window < "u" && typeof window.document < "u" && typeof window.navigator < "u", $t = jt && /iPad|iPhone|iPod/.test(window.navigator.userAgent);
function St(e) {
  C(() => {
    window.requestAnimationFrame(() => {
      if (e.current instanceof HTMLElement) {
        const n = e.current;
        n.closest("label") || n.id && document.querySelector(`label[for="${n.id}"]`) || console.warn(
          "Form element missing <Label>. Please set an id={exampleId} and corresponding <Label htmlFor={exampleId}>:",
          n
        );
      }
    });
  }, [e]);
}
function X(e) {
  const { options: n } = $(he);
  return we(
    (t) => {
      e && Le(
        {
          eventVersion: Lt,
          eventSource: xt,
          eventLabel: "",
          ...t,
          ...e === !0 ? {} : e
        },
        n
      );
    },
    [e, n]
  );
}
function q(e) {
  return e instanceof HTMLElement ? (e.innerText || e.textContent || e.getAttribute("aria-label") || "").replace(/\n/g, " ").trim() : "";
}
function Et(e) {
  if (!(e instanceof HTMLElement))
    return "";
  const n = q(e.querySelector(vt.helpText)), t = q(e.querySelector(Ct.message));
  return q(e).replace(n, "").replace(t, "");
}
const Nt = "_alert_1fb5w_1", Mt = "_close_1fb5w_38", Tt = "_icon_1fb5w_59", It = "_success_1fb5w_71", At = "_warning_1fb5w_77", Dt = "_error_1fb5w_83", zt = "_outlined_1fb5w_89", A = {
  alert: Nt,
  close: Mt,
  icon: Tt,
  success: It,
  warning: At,
  error: Dt,
  outlined: zt
}, Zt = {
  error: Fe,
  informative: We,
  success: Pe,
  warning: Ve
}, Bt = x(function({
  children: n,
  className: t,
  closeLabel: s,
  onClose: a,
  severity: o = "informative",
  tracking: r = !1,
  variant: l = "filled",
  ...c
}, h) {
  const d = J(null), [m, b] = j(!1), [w, u] = j(!1), v = typeof r == "object" && !!r.eventLabel, g = X(v && r), _ = Zt[o], y = (L) => {
    g({
      eventCategory: `alert_${o}`,
      eventAction: "close"
    }), u(!0), a && a(L);
  };
  return Q(h, () => d.current), C(() => {
    m || (b(!0), g({
      eventCategory: `alert_${o}`,
      eventAction: "impression"
    }));
  }, [m, g, o]), /* @__PURE__ */ f(
    "section",
    {
      ...c,
      className: k(
        t,
        A.alert,
        A[o],
        A[l]
      ),
      hidden: w,
      ref: d,
      children: [
        /* @__PURE__ */ i(_, { className: A.icon }),
        s && /* @__PURE__ */ i(
          "button",
          {
            "aria-label": s,
            className: A.close,
            onClick: y,
            type: "button",
            children: /* @__PURE__ */ i(Se, {})
          }
        ),
        n
      ]
    }
  );
}), Ot = "_badge_1l7bu_1", Vt = "_sm_1l7bu_2", Pt = "_informative_1l7bu_15", Rt = "_success_1l7bu_18", Ht = "_warning_1l7bu_22", Wt = "_error_1l7bu_26", Ft = "_suggestive_1l7bu_30", ne = {
  badge: Ot,
  sm: Vt,
  informative: Pt,
  success: Rt,
  warning: Ht,
  error: Wt,
  suggestive: Ft
}, qt = x(function({ className: n, max: t, severity: s = "informative", size: a = "md", ...o }, r) {
  const l = Number(String(o.children).trim()) || 0, c = Number(t === !0 ? 10 : t) || 1 / 0;
  return l > c && (o.children = `${c}+`), /* @__PURE__ */ i(
    "span",
    {
      ...o,
      className: k(
        ne.badge,
        ne[a],
        ne[s],
        n
      ),
      ref: r
    }
  );
}), Ut = "_spinner_5ijwx_9", Gt = "_lg_5ijwx_21", Kt = "_rotate_5ijwx_1", Jt = "_dash_5ijwx_1", Qt = "_sm_5ijwx_41", Xt = "_md_5ijwx_42", _e = {
  spinner: Ut,
  lg: Gt,
  rotate: Kt,
  dash: Jt,
  sm: Qt,
  md: Xt
}, Yt = x(
  function({ className: n, children: t, timedContent: s, size: a = "md", ...o }, r) {
    const [l, c] = j(t);
    return C(() => {
      c(t), Object.entries(s || {}).forEach(
        ([h, d]) => setTimeout(() => c(d), Number(h))
      );
    }, [s, t]), /* @__PURE__ */ f(
      "span",
      {
        ...o,
        "aria-live": "polite",
        className: k(_e.spinner, _e[a], n),
        ref: r,
        role: $t ? void 0 : "progressbar",
        tabIndex: 0,
        children: [
          /* @__PURE__ */ f("svg", { viewBox: "25 25 50 50", "aria-hidden": "true", children: [
            /* @__PURE__ */ i("circle", { cx: "50", cy: "50", r: "20" }),
            /* @__PURE__ */ i("circle", { cx: "50", cy: "50", r: "20" })
          ] }),
          l
        ]
      }
    );
  }
), en = "_button_1t2w7_25", tn = "_arrow_1t2w7_57", nn = "_action_1t2w7_72", on = "_spinner_1t2w7_72", sn = "_flexible_1t2w7_90", rn = "_md_1t2w7_100", an = "_secondary_1t2w7_108", cn = "_primary_1t2w7_117", ln = "_critical_1t2w7_126", dn = "_unset_1t2w7_135", N = {
  button: en,
  arrow: tn,
  action: nn,
  spinner: on,
  flexible: sn,
  md: rn,
  secondary: an,
  primary: cn,
  critical: ln,
  unset: dn
}, oe = /* @__PURE__ */ i(Yt, { className: N.spinner, size: "md" }), O = x(function({
  arrow: n,
  children: t = " ",
  // Non breaking space ensuring consistent height
  className: s,
  disabled: a = !1,
  flexible: o = !1,
  icon: r,
  iconPosition: l = "left",
  loading: c = !1,
  onClick: h,
  as: d,
  size: m = "md",
  variant: b = "primary",
  tracking: w = !0,
  ...u
}, v) {
  const g = d || (u.href ? "a" : "button"), _ = b.split("-")[0], y = a || c, L = _ === "action", T = k(
    N.button,
    N[_],
    N[m],
    o && N.flexible,
    s
  ), Y = X(w), ee = (te) => {
    if (y)
      return te.preventDefault();
    Y({
      eventCategory: `button_${_}`,
      eventAction: "click",
      eventLabel: q(te.currentTarget)
    }), h && h(te);
  };
  let S = null, E = null;
  return n === "left" ? S = /* @__PURE__ */ i(ue, { className: N.arrow }) : (n || _ === "action" && !r) && (E = /* @__PURE__ */ i(ue, { className: N.arrow })), r && l === "left" && (S = r), r && l === "right" && (E = r), L && c && (S ? S = oe : E && (E = oe)), u.href || Object.assign(u, { href: void 0 }), g === "button" && Object.assign(u, { type: u.type || g }), y && Object.assign(u, {
    [g === "button" ? "disabled" : "aria-disabled"]: !0,
    "aria-busy": c || void 0,
    tabIndex: -1
  }), /* @__PURE__ */ f(g, { ...u, className: T, onClick: ee, ref: v, children: [
    c && !L && oe,
    S,
    /* @__PURE__ */ i("span", { children: t }),
    E
  ] });
}), un = "_chevron_9ku18_14", gn = "_open_9ku18_33", ke = {
  chevron: un,
  open: gn
}, pn = x(function({ className: n, open: t, ...s }, a) {
  return /* @__PURE__ */ i(
    Ue,
    {
      ...s,
      className: k(ke.chevron, n, {
        [ke.open]: t
      }),
      ref: a
    }
  );
}), hn = K(
  () => {
  }
), fn = "_input_1h8ia_13", mn = "_htmlSize_1h8ia_34", vn = "_isBoolean_1h8ia_98", _n = "_isSwitch_1h8ia_146", kn = "_isDisabled_1h8ia_167", bn = "_isInvalid_1h8ia_171", yn = "_shake_1h8ia_1", I = {
  input: fn,
  htmlSize: mn,
  isBoolean: vn,
  isSwitch: _n,
  isDisabled: kn,
  isInvalid: bn,
  shake: yn
}, wn = x(function({ classNameWrapper: n, hidden: t, invalid: s, prefix: a, suffix: o, style: r, size: l, ...c }, h) {
  c.tracking === void 0 && (c.tracking = !0), $(hn)(c);
  const d = J(null), m = c.type === "checkbox" || c.type === "radio", b = c.type === "switch", w = k(I.input, n, {
    [I.htmlSize]: l,
    [I.isBoolean]: m || b,
    [I.isDisabled]: c.disabled,
    [I.isInvalid]: s,
    [I.isSwitch]: b
  }), u = X(c.tracking);
  return Q(h, () => d.current), Cn(d, m, b), St(d), C(() => {
    const v = d.current, g = ({ target: _ }) => {
      var T;
      const y = _, L = y.checked ? "checked" : "unchecked";
      u({
        eventCategory: "input",
        eventAction: m ? L : "change",
        eventLabel: Et((T = y.labels) == null ? void 0 : T[0])
      });
    };
    return v == null || v.addEventListener("change", g), () => v == null ? void 0 : v.removeEventListener("change", g);
  }, [u, m]), /* @__PURE__ */ f("span", { className: w, hidden: t, children: [
    m || b || a || c.type === "search" && /* @__PURE__ */ i($e, {}),
    /* @__PURE__ */ i(
      "input",
      {
        ...c,
        tracking: void 0,
        style: { ...r, "--size": l },
        type: c.type === "switch" ? "checkbox" : c.type,
        "aria-invalid": c["aria-invalid"] || s || void 0,
        ref: d
      }
    ),
    m || b || o
  ] });
}), Cn = (e, n, t) => {
  C(() => {
    var a;
    const s = (a = e.current) == null ? void 0 : a.closest("label");
    s && (s.toggleAttribute("data-has-boolean", n || t), s.toggleAttribute("data-has-switch", t));
  }, [e, n, t]);
}, xn = "_title_1008n_1", Ln = "_size1_1008n_7", jn = "_size2_1008n_11", $n = "_size3_1008n_14", Sn = "_size4_1008n_17", En = "_size5_1008n_20", Nn = "_size6_1008n_24", Mn = "_uppercase_1008n_28", se = {
  title: xn,
  size1: Ln,
  size2: jn,
  size3: $n,
  size4: Sn,
  size5: En,
  size6: Nn,
  uppercase: Mn
}, U = x(function({ children: n, className: t, size: s, as: a, text: o, uppercase: r, ...l }, c) {
  const h = a || "h2", d = Number(String(s || a).replace(/^h([1-6])$/i, "$1")) || 1, m = k(
    se.title,
    se[`size${Math.max(1, Math.min(6, d))}`],
    r && se.uppercase,
    t
  );
  return /* @__PURE__ */ f(h, { ...l, className: m, ref: c, children: [
    o ? Tn(o) : null,
    n
  ] });
});
function Tn(e) {
  return e.replace(/--/g, "­").replace(/__/g, " ").replace(/(\d)\s(\d)/g, "$1 $2");
}
const In = "_label_slop9_1", An = {
  label: In
}, Dn = x(function({ className: n, ...t }, s) {
  const a = k(An.label, n);
  return /* @__PURE__ */ i("label", { ...t, className: a, ref: s });
}), zn = "_dialog_y29op_1", Zn = "_box_y29op_1", Bn = "_backdrop_y29op_1", On = "_drawer_y29op_52", Vn = "_sm_y29op_80", Pn = "_lg_y29op_83", Rn = "_close_y29op_87", V = {
  dialog: zn,
  box: Zn,
  backdrop: Bn,
  drawer: On,
  sm: Vn,
  lg: Pn,
  close: Rn
};
let re = !1;
const Hn = x(function({
  children: n,
  className: t,
  closeLabel: s,
  open: a = !1,
  size: o = "lg",
  strict: r = !1,
  tracking: l = !0,
  variant: c = "box",
  ...h
}, d) {
  const m = J(null), b = X(l), w = we(
    (u, v = "_dismiss") => {
      const g = m.current, _ = typeof (g == null ? void 0 : g.close) == "function";
      !g || g.hidden !== u || (_ ? g[u ? "showModal" : "close"]() : u || g.dispatchEvent(new CustomEvent("close")), g.hidden = !u, u && setTimeout(() => g.focus()), b({
        eventCategory: `modal_${c}`,
        eventAction: u ? "open" : `close${v}`,
        eventLabel: (g == null ? void 0 : g.getAttribute("aria-label")) || "modal"
      }));
    },
    [c, b]
  );
  return Q(d, () => m.current), C(() => w(a, ""), [a, w]), /* @__PURE__ */ f(
    "dialog",
    {
      ...h,
      hidden: !0,
      className: k(
        V.dialog,
        V[c],
        V[o],
        t
      ),
      onKeyDown: (u) => {
        h.onKeyDown && h.onKeyDown(u), u.key === "Escape" && (u.preventDefault(), r || w(!1));
      },
      onPointerDown: (u) => {
        const { clientX: v, clientY: g, currentTarget: _, target: y } = u, { top: L, left: T, right: Y, bottom: ee } = _.getBoundingClientRect(), S = y !== _ && _.contains(y), E = L <= g && T <= v && g <= ee && v <= Y;
        re = S || E ? "inside" : "outside";
      },
      onClick: () => {
        re === "outside" && !r && w(!1), re = !1;
      },
      ref: m,
      children: [
        s && /* @__PURE__ */ i(
          "button",
          {
            "aria-label": s,
            className: V.close,
            onClick: () => w(!1),
            type: "button",
            children: /* @__PURE__ */ i(Se, {})
          }
        ),
        n
      ]
    }
  );
}), Wn = "_text_1ptno_1", Fn = "_lead_1ptno_13", qn = "_large_1ptno_17", Un = "_body_1ptno_21", Gn = "_small_1ptno_25", ie = {
  text: Wn,
  "weight-400": "_weight-400_1ptno_4",
  "weight-500": "_weight-500_1ptno_7",
  "weight-700": "_weight-700_1ptno_10",
  lead: Fn,
  large: qn,
  body: Un,
  small: Gn
}, ae = x(function({ as: n, className: t, size: s = "inherit", weight: a = 400, ...o }, r) {
  const l = n || "p", c = k(
    t,
    ie.text,
    ie[s],
    ie[`weight-${a}`]
  );
  return /* @__PURE__ */ i(l, { ...o, className: c, ref: r });
}), z = x(function({
  as: n,
  badge: t,
  children: s,
  className: a,
  classNameExpand: o = p.desktopThirdLevel,
  icon: r,
  label: l,
  open: c,
  selected: h,
  ...d
}, m) {
  const b = n || (d.href ? "a" : "button"), w = s ? !!c : void 0;
  return b === "button" && Object.assign(d, { type: "button" }), /* @__PURE__ */ f(D, { children: [
    /* @__PURE__ */ f(
      b,
      {
        "aria-current": !!h || void 0,
        "aria-expanded": w,
        "data-expanded": w,
        className: k(p.item, a),
        ref: m,
        ...d,
        children: [
          r,
          !t || /* @__PURE__ */ i(
            qt,
            {
              className: p.badge,
              "data-badge": t,
              severity: "informative",
              size: "sm"
            }
          ),
          l,
          !!s && /* @__PURE__ */ i(pn, { className: p.chevron })
        ]
      }
    ),
    !!s && /* @__PURE__ */ i("div", { className: k(p.expand, o), children: /* @__PURE__ */ i("div", { children: s }) })
  ] });
}), Kn = "@gjensidige/core-navigation", Jn = "3.1.4", M = K({}), Ee = K(!1), Ne = typeof window < "u" && typeof window.document < "u" && typeof window.navigator < "u";
function Qn(e) {
  C(() => {
    if (!document.elementFromPoint)
      return;
    const n = document.elementFromPoint(0, 0), t = window.getComputedStyle(n).backgroundColor, s = document.querySelector('meta[name="theme-color"]') || document.head.appendChild(document.createElement("meta"));
    s.setAttribute("name", "theme-color"), s.setAttribute("content", t);
  }, [e]);
}
function Xn(e, n = !1) {
  const [t, s] = j(n);
  return C(() => {
    if (!window.matchMedia)
      return;
    const a = window.matchMedia(e), o = () => s(a.matches);
    return o(), a.addEventListener("change", o), () => a.removeEventListener("change", o);
  }, [e]), t;
}
function Yn(e) {
  C(() => {
    const n = document.documentElement, t = e.current, s = () => n.style.setProperty("--nav-height", `${t == null ? void 0 : t.offsetHeight}px`);
    return s(), window.addEventListener("load", s), window.addEventListener("resize", s), () => window.removeEventListener("resize", s);
  }, [e]);
}
const eo = (e) => {
  const { options: n } = $(he);
  if (e)
    return (t) => setTimeout(() => {
      const s = t.target, a = s.closest("[aria-expanded]"), o = to(s);
      o && Le(
        {
          eventAction: "click",
          eventCategory: a ? "dropdown" : "link",
          eventKey: "navigation",
          eventLabel: o,
          eventSource: Kn,
          eventVersion: Jn,
          ...e === !0 ? {} : e
        },
        n
      );
    });
};
function to(e, n = []) {
  var t;
  for (let s = e; s; s = s.parentElement) {
    const o = s.classList.contains(p.expand) && n.length ? s.previousElementSibling : s;
    if (o && o.classList.contains(p.item)) {
      const r = o.closest(`.${p.actions}`), l = o.getAttribute("data-tracking"), c = o.textContent || o.getAttribute("aria-label") || "";
      if (o.getAttribute("aria-expanded") === "false")
        return "";
      if (r || typeof l == "string")
        return l || c;
      const h = `:scope > .${p.item}:not([data-tracking])`, d = ((t = o.parentElement) == null ? void 0 : t.querySelectorAll(h)) || [];
      n.unshift(`${Array.from(d).indexOf(o) + 1}-${c}`);
    }
  }
  return n.join("/");
}
const no = (e) => C(() => {
  const n = (t) => {
    const s = t.target, a = s.closest(`.${p.item}[aria-expanded]`), o = a && (e || a.nodeName === "BUTTON"), r = a && a.getAttribute("aria-expanded") === "true";
    e || be(`button.${p.item}[aria-expanded="true"]`).filter((l) => {
      var c;
      return !((c = l.nextElementSibling) != null && c.contains(s));
    }).forEach((l) => l.setAttribute("aria-expanded", "false")), o && !t.defaultPrevented && (a.setAttribute("aria-expanded", `${!r}`), t.preventDefault(), !r && e && a.scrollIntoView({ behavior: "smooth" }));
  };
  return be(`.${p.item}[data-expanded]`).forEach((t) => {
    const s = t.getAttribute("data-expanded");
    t.setAttribute("aria-expanded", s);
  }), document.addEventListener("click", n), () => document.removeEventListener("click", n);
}, [e]);
function be(e, n = document) {
  return Array.from(n.querySelectorAll(e));
}
const oo = ({
  badge: e = 0,
  className: n,
  href: t = "",
  label: s,
  ...a
}) => {
  const o = $(M).cart, [r, l] = j({
    items: e || P("cart-items") || 0,
    url: t || P("cart-url") || ""
  }), [c, h] = j(!1);
  return C(() => h(!0), []), C(() => {
    const d = ({ detail: m }) => l({ ...r, ...m });
    return P("cart-items", r.items), P("cart-url", r.url), document.addEventListener("nav-cart", d), () => document.removeEventListener("nav-cart", d);
  }, [r]), /* @__PURE__ */ i(D, { children: c && /* @__PURE__ */ i(
    z,
    {
      ...a,
      badge: r.items,
      className: k(p.cart, n),
      "data-tracking": "",
      as: "a",
      hidden: !(r.url && r.items),
      href: r.url,
      icon: /* @__PURE__ */ i(Re, {}),
      label: s || o
    }
  ) });
};
function P(e, n) {
  try {
    const t = window.sessionStorage;
    return typeof n > "u" ? t.getItem(e) || "" : (n ? t.setItem(e, String(n).trim()) : t.removeItem(e), !0);
  } catch {
    return !1;
  }
}
const so = ({
  messages: e = !1,
  filter: n
}) => {
  const [t, s] = j([]), a = $(M).close;
  return C(() => {
    Array.isArray(e) ? s(e) : e === !1 ? s([]) : e && fetch(e).then((o) => o.json()).then((o) => s(o));
  }, [e]), /* @__PURE__ */ i("div", { className: p.systemMessages, children: ro(t, n).map(
    ({ _id: o, title: r, text: l, severity: c }) => /* @__PURE__ */ f(
      Bt,
      {
        severity: c,
        closeLabel: a,
        onClose: () => window.localStorage.setItem(o, "clicked"),
        tracking: {
          eventCategory: "system-message",
          eventLabel: `alert_${c}`
        },
        children: [
          r ? /* @__PURE__ */ i(U, { children: r }) : null,
          /* @__PURE__ */ i("div", { dangerouslySetInnerHTML: { __html: l } })
        ]
      },
      o
    )
  ) });
};
function ro(e, n) {
  var r;
  if (!Ne || !Array.isArray(e))
    return [];
  const { application: t, group: s, location: a } = n || {}, o = a || ((r = window == null ? void 0 : window.location) == null ? void 0 : r.pathname) || "";
  return e.filter(
    (l) => {
      var c;
      return !((c = window == null ? void 0 : window.localStorage) != null && c.getItem(l._id)) && (!s || l.group === s) && (!l.location || o.match(l.location)) && (l.application.length === 0 || !t || l.application.includes(t));
    }
  );
}
/*! js-cookie v3.0.5 | MIT */
function R(e) {
  for (var n = 1; n < arguments.length; n++) {
    var t = arguments[n];
    for (var s in t)
      e[s] = t[s];
  }
  return e;
}
var io = {
  read: function(e) {
    return e[0] === '"' && (e = e.slice(1, -1)), e.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function(e) {
    return encodeURIComponent(e).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    );
  }
};
function ge(e, n) {
  function t(a, o, r) {
    if (!(typeof document > "u")) {
      r = R({}, n, r), typeof r.expires == "number" && (r.expires = new Date(Date.now() + r.expires * 864e5)), r.expires && (r.expires = r.expires.toUTCString()), a = encodeURIComponent(a).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
      var l = "";
      for (var c in r)
        r[c] && (l += "; " + c, r[c] !== !0 && (l += "=" + r[c].split(";")[0]));
      return document.cookie = a + "=" + e.write(o, a) + l;
    }
  }
  function s(a) {
    if (!(typeof document > "u" || arguments.length && !a)) {
      for (var o = document.cookie ? document.cookie.split("; ") : [], r = {}, l = 0; l < o.length; l++) {
        var c = o[l].split("="), h = c.slice(1).join("=");
        try {
          var d = decodeURIComponent(c[0]);
          if (r[d] = e.read(h, d), a === d)
            break;
        } catch {
        }
      }
      return a ? r[a] : r;
    }
  }
  return Object.create(
    {
      set: t,
      get: s,
      remove: function(a, o) {
        t(
          a,
          "",
          R({}, o, {
            expires: -1
          })
        );
      },
      withAttributes: function(a) {
        return ge(this.converter, R({}, this.attributes, a));
      },
      withConverter: function(a) {
        return ge(R({}, this.converter, a), this.attributes);
      }
    },
    {
      attributes: { value: Object.freeze(n) },
      converter: { value: Object.freeze(e) }
    }
  );
}
var Me = ge(io, { path: "/" });
const ao = "_cookieConsent_8lnmi_1", co = "_buttons_8lnmi_16", lo = "_preference_8lnmi_21", ce = {
  cookieConsent: ao,
  buttons: co,
  preference: lo
}, Te = "CONSENTMGR", pe = Me.get(Te), fe = {
  affiliates: 1,
  analytics: 1,
  big_data: 1,
  cdp: 1,
  cookiematch: 1,
  crm: 1,
  display_ads: 1,
  email: 1,
  engagement: 1,
  misc: 1,
  mobile: 1,
  monitoring: 1,
  personalization: 1,
  search: 1,
  social: 1
}, G = {
  ...fe,
  analytics: 0,
  display_ads: 0,
  personalization: 0
}, uo = () => {
  const e = "COOKIE_TITLE_ID", n = H(), t = $(M).consent, [s, a] = j(pe ? !1 : "intro");
  return C(() => {
    const o = () => {
      const [, r] = window.location.hash.split("#cookie:");
      (r === "settings" || r === "intro") && a(r);
    };
    return window.addEventListener("hashchange", o), () => window.removeEventListener("hashchange", o);
  }, []), C(() => {
    setTimeout(() => {
      var o;
      return (o = document.getElementById(e)) == null ? void 0 : o.focus();
    });
  }, [s, e]), /* @__PURE__ */ i(D, { children: s && /* @__PURE__ */ i(
    Hn,
    {
      open: !0,
      strict: !0,
      className: ce.cookieConsent,
      "aria-label": t.title,
      closeLabel: pe && s === "settings" && t.close || "",
      onClose: () => a(!1),
      children: s === "intro" ? /* @__PURE__ */ f(D, { children: [
        /* @__PURE__ */ i(
          U,
          {
            id: e,
            size: "4",
            tabIndex: -1,
            as: "h1",
            text: t.title
          }
        ),
        /* @__PURE__ */ i(ae, { dangerouslySetInnerHTML: { __html: t.text } }),
        /* @__PURE__ */ f("div", { className: ce.buttons, children: [
          /* @__PURE__ */ i(
            O,
            {
              variant: "secondary",
              onClick: () => {
                W(!0), le(), a(!1), de("all");
              },
              children: t.accept
            }
          ),
          /* @__PURE__ */ i(
            O,
            {
              variant: "secondary",
              onClick: () => {
                W(G), le(), a(!1), de("none");
              },
              children: t.necessary
            }
          )
        ] }),
        /* @__PURE__ */ i(
          O,
          {
            variant: "action",
            icon: /* @__PURE__ */ i(qe, {}),
            onClick: () => a("settings"),
            children: t.edit
          }
        )
      ] }) : /* @__PURE__ */ f(D, { children: [
        /* @__PURE__ */ i(
          U,
          {
            id: e,
            size: "4",
            tabIndex: -1,
            as: "h1",
            text: t.preferences_title
          }
        ),
        /* @__PURE__ */ i(ae, { children: t.preferences_text }),
        t.preferences.map(({ id: o, title: r, text: l }, c) => /* @__PURE__ */ f("div", { children: [
          /* @__PURE__ */ i(U, { size: "5", as: "h2", text: r }),
          /* @__PURE__ */ f("div", { className: ce.preference, children: [
            /* @__PURE__ */ i(ae, { children: l }),
            /* @__PURE__ */ f("div", { children: [
              /* @__PURE__ */ i(Dn, { htmlFor: `${r}_${o}`, hidden: !0, children: r }),
              /* @__PURE__ */ i(
                wn,
                {
                  disabled: !o,
                  defaultChecked: !o || !!n[o],
                  id: `${r}_${o}`,
                  onChange: ({ target: h }) => o && W({
                    ...H(),
                    [o]: Number(h.checked)
                  }),
                  type: "switch"
                }
              )
            ] })
          ] })
        ] }, `${r}_${o}_${c}`)),
        /* @__PURE__ */ i(
          O,
          {
            variant: "secondary",
            onClick: () => {
              le(), W(H()), a(!1), de(go(H()));
            },
            children: t.save
          }
        )
      ] })
    }
  ) });
}, Z = () => Ne && window.utag && window.utag.gdpr, H = () => {
  const e = { ...G }, n = Z() && Z().getConsentState();
  return String(n) === "1" ? fe : (Array.isArray(n) && n.forEach(({ name: t, ct: s }) => {
    e[t] = Number(s);
  }), e);
}, W = (e) => {
  Z() ? Z().setPreferencesValues(e === !0 ? fe : e) : Me.set(Te, `ts:${Date.now()}|consent:false`);
}, le = () => {
  if (!Z() || pe)
    return;
  const e = window.utag && window.utag.udoname || "utag_data";
  window.utag[e] && window.utag.view(window[e]);
}, go = (e) => Object.values(e).every((n) => n === 1) ? "all" : Object.keys(G).every(
  (n) => G[n] === e[n]
) ? "none" : "some", de = (e) => {
  try {
    fetch("/api-tools/v1/open/remote-logging/MESSAGE?severity=INFO", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Applikasjon: "INTERNETT",
        "X-ClientId": "cookie-consent"
      },
      body: JSON.stringify({
        message: "Cookie consent interaction",
        extras: [
          { key: "path", value: window.location.pathname },
          { key: "domain", value: window.location.hostname },
          { key: "consent", value: e }
        ]
      })
    });
  } catch {
  }
}, po = () => /* @__PURE__ */ f(
  "svg",
  {
    "aria-hidden": "true",
    fill: "currentColor",
    focusable: "false",
    height: "2em",
    viewBox: "0 0 155 38.5",
    width: "7.75em",
    children: [
      /* @__PURE__ */ i("path", { d: "m144.39 29.44.02-.04-.64-.99h-.02l-.55.89v.02l1.19.11Zm-1.33-3.42-.02.04.69 1.26h.04l.62-1.22-.02-.04-1.31-.04Zm-.55.24-.02.02.09 2.89.02.02.77-1.35v-.04l-.86-1.53Zm2.59 3.05v-3.14l-.02-.02-.93 1.68v.04l.91 1.48.04-.04Zm-4.44-11.2h-.04l.05 1.39.4.71c.15.24 1.22 5.33 1.22 5.33l1.35-.68a.98.98 0 0 1-.2-.62c0-.11.02-.2.04-.29-.05-.02-.38-.05-.44-.15a3.83 3.83 0 0 1 .04-1.42l-.09-.16c-.18-.26-.97-1.11-.95-1.26 0-.13.15-.31.15-.31l-1.53-2.54Zm-6.96 15.32c-.02-.07-.16-1.31-.18-1.63-1.44-.13-2.12-.26-2.3-.47-.2-.24 1.64-11.47 1.79-11.67.09-.13.55-.47.58-.6.04-.11.02-2.43 0-3h-.07c-.09 0-2.52 2.39-3.32 2.3a4.02 4.02 0 0 1-1.5-.58l1.26 19.91c1.37.42 2.79.69 4.27.8l.42-.68.02-1.08-.58-3.1s-.35-.11-.38-.2Zm2.01-33.44c-2.87 0-5.57.62-8.02 1.74l.71 11.2c.29-.04.53-.04.57 0 .09.13.46 1 .49 1.17.02.09-.02.2-.09.31l.97.27s1.74-2.34 2.23-2.63l2.08-.95a.97.97 0 0 0 .11-.18l.18-1.5c.02-.18.4-.53.49-.8.07-.27.05-1.61.09-1.74.05-.2 1.17-.95 1.46-1.13a6.2 6.2 0 0 1 1.61-.02c.55.11 1.02.6 1.02.79l-.05 1.99c0 .16.62 1.17.62 1.48s-.07 1.02-.07 1.19c0 .04.04.15.09.27l2.06 1.26c.29.18 1.19 4.31 1.19 4.31l1.19 2.34s.35-.09.42-.04c.09.07.18 2.76.18 2.76.15.31.55 1.08.55 1.33 0 .29-.29.53-.6.71l.02.16c0 .26-.09.49-.24.66.44.22 1.17.58 1.17.64 0 .16.02.31 0 4.18 0 0-.47.38-.51.38l-2.65-.16c.07.75.11 1.37.05 1.55-.46.22-1.64.35-2.45.4-.16.6-.69 2.47-.82 2.47h-.33s-1 1.42-1 1.57c0 .13.37 1.37.37 1.37l.97.82a19.3 19.3 0 0 0-4.06-38.17Zm-8.93 16.49a3.17 3.17 0 0 1-.64-1.79c.02-.55.38-1.19.49-1.39.04-.04.15-.09.31-.15l-.69-10.81a19.25 19.25 0 0 0 2.21 34.86l-1.3-20.55a.84.84 0 0 1-.38-.18Z" }),
      /* @__PURE__ */ i("path", { d: "M61.09 10.12a1.45 1.45 0 1 1 0 2.9c-.8 0-1.44-.62-1.44-1.44s.64-1.46 1.44-1.46Zm-1.1 5.77c0-.22.18-.42.4-.42h1.39c.22 0 .42.18.42.42v10.54h-1.81a.4.4 0 0 1-.4-.42V15.89Zm20.4-5.77a1.45 1.45 0 1 1 0 2.9c-.8 0-1.44-.62-1.44-1.44s.64-1.46 1.44-1.46Zm-1.1 5.77c0-.22.18-.42.42-.42h1.39c.22 0 .42.18.42.42v10.54h-1.81a.42.42 0 0 1-.42-.42V15.89Zm-3.84-6.01h-1.39a.42.42 0 0 0-.42.42v6.14a5.21 5.21 0 0 0-3.36-1.19c-1.02 0-1.94.26-2.68.69a5.75 5.75 0 0 0-2.81 5c0 2.19 1.13 4 2.79 4.99.75.44 1.77.73 2.74.73 1.3 0 2.48-.44 3.38-1.24V26c0 .22.18.42.42.42h1.74V10.3a.4.4 0 0 0-.4-.42Zm-1.79 13.11a3.81 3.81 0 0 1-3.01 1.57c-2.12 0-3.63-1.66-3.63-3.62s1.39-3.62 3.52-3.62c1.33 0 2.45.68 3.12 1.55v4.11Zm21.09-7.52h-1.31a.42.42 0 0 0-.42.42v.58a5.15 5.15 0 0 0-3.43-1.24c-1.02 0-1.94.26-2.68.69-1.64.99-2.81 2.81-2.81 5s1.13 4 2.79 4.99c.75.44 1.77.73 2.74.73 1.3 0 2.43-.42 3.31-1.19v.6c0 1.37-.22 2.21-.6 2.81-.53.82-1.46 1.26-2.65 1.26a4.09 4.09 0 0 1-3.38-1.68.38.38 0 0 0-.51.02l-.04.04-1.28 1.19c.69 1.1 2.48 2.54 5.33 2.54 2.17 0 3.84-1 4.73-2.7.44-.86.66-1.95.66-3.58V15.89c-.04-.24-.22-.42-.44-.42Zm-1.81 7.52a3.81 3.81 0 0 1-3.01 1.57c-2.12 0-3.63-1.66-3.63-3.62s1.39-3.62 3.51-3.62c1.33 0 2.45.68 3.12 1.55v4.11h.02Zm-59.43-2.05c0-3.23-2.21-5.7-5.26-5.7s-5.33 2.43-5.33 5.7 2.47 5.7 5.66 5.7c2.23 0 3.8-1 4.62-2.05l-1.21-1.15a.43.43 0 0 0-.44 0l-.13.11c-.6.6-1.44 1.15-2.81 1.15a3.52 3.52 0 0 1-3.54-3.31h8.02c.22 0 .42-.16.44-.37-.02 0-.02-.07-.02-.09Zm-8.27-1.41a3.18 3.18 0 0 1 3.07-2.37c1.3 0 2.56.99 2.89 2.37h-5.95Zm83.08 1.41c0-3.23-2.21-5.7-5.26-5.7s-5.33 2.43-5.33 5.7 2.47 5.7 5.66 5.7c2.23 0 3.8-1 4.6-2.05l-1.21-1.15a.43.43 0 0 0-.44 0l-.13.11a3.7 3.7 0 0 1-2.81 1.15 3.51 3.51 0 0 1-3.54-3.31h8.02c.22 0 .42-.16.44-.37v-.09Zm-8.27-1.41a3.16 3.16 0 0 1 3.07-2.37c1.31 0 2.56.99 2.89 2.37h-5.95Zm-80.84-9.41a1.45 1.45 0 1 1 0 2.9c-.8 0-1.44-.62-1.44-1.44s.64-1.46 1.44-1.46Zm1.11 17.24c0 1.46-.2 2.37-.69 3.07a4.28 4.28 0 0 1-3.58 1.83c-.47 0-1-.07-1.3-.16l.37-1.63a.43.43 0 0 1 .49-.33l.4.02c.62 0 1.3-.27 1.68-.77.31-.4.42-.95.42-1.95V15.9c0-.22.18-.42.42-.42h1.39c.22 0 .42.18.42.42v11.05l-.02.42ZM45.6 17.17c-.93-1.19-2.37-1.94-3.98-1.94s-2.7.71-3.29 1.28v-.62c0-.22-.18-.42-.4-.42h-1.31a.42.42 0 0 0-.42.42v10.12c0 .22.18.42.42.42h1.39c.22 0 .42-.18.42-.42v-7.1a4.06 4.06 0 0 1 3.14-1.55c.91 0 1.75.42 2.26 1.08.4.49.66 1.13.66 2.54l.02.4v4.66c0 .22.18.42.42.42h1.79v-5.35c-.04-1.92-.42-3.03-1.11-3.93Zm4.26 6.65s.02 0 0 0Zm-.91 1.31a6.77 6.77 0 0 0 4.42 1.52c2.14 0 4.07-1.28 4.07-3.36 0-2.26-2.26-3.03-3.98-3.47-1.1-.27-1.95-.53-1.95-1.28 0-.86.91-1.37 1.99-1.37.75 0 1.41.26 2.01.64.2.11.46.05.58-.13l.58-.8.04-.05c.16-.22.15-.42-.02-.58l-.05-.05a5.63 5.63 0 0 0-3.29-.95c-1.95 0-4.05 1.08-4.05 3.42 0 1.53 1.19 2.37 2.52 2.81 1.61.53 3.43.6 3.43 1.86 0 .86-.95 1.37-1.92 1.37s-1.95-.33-2.89-.95a.43.43 0 0 0-.57.05l-.93 1.33Zm-34.16-8.2a.42.42 0 0 0-.42-.42H7.8v1.83c.02.22.2.38.4.38h4.26v4.2a5.67 5.67 0 0 1-4 1.52c-3.47 0-6.12-2.5-6.12-6.17s2.59-6.17 5.92-6.17c1.59 0 3.12.66 4.11 1.55.15.15.38.15.55.02.02 0 .02-.02.02-.02h-.02l.99-.97s0-.02.02-.02a.4.4 0 0 0 .04-.51l-.04-.05v-.02a8.17 8.17 0 0 0-5.68-2.23C3.56 9.89.01 13.56.01 18.27s3.58 8.38 8.46 8.38a8.31 8.31 0 0 0 6.34-3.03v-6.68Z" })
    ]
  }
), ho = {
  cart: "Indkøbskurv",
  close: "Luk",
  code: "da",
  gotofront: "Til forsiden",
  home: "Til forsiden",
  login: "Log ind",
  menu: "Meny",
  search: "Søg",
  skip: "Hop til indhold",
  consent: {
    accept: "OK, helt fint med mig",
    close: "Luk modalt vindue",
    edit: "Ret indstilinger",
    necessary: "Kun nødvendige",
    save: "Gem indstillinger",
    text: 'For at give dig den bedste oplevelse bruger vi cookies på gjensidige.dk. Vi bruger både egne cookies og cookies fra tredjeparter. Hvis du accepterer alle cookies, giver du samtykke til, at vi registrerer hvordan du bruger hjemmesiden, gøre markedsføring mere relevant, giver dig mulighed for at bruge yderligere funktionalitet og indsamle, behandle og videregive oplysninger om dig. Til enhver tid kan du tilbagekalde dit cookiesamtykke. <a href="/persondata-og-cookies">Du kan læse mere i vores cookie- og persondatapolitik.</a>',
    title: "Hjemmesiden bruger cookies",
    preferences_title: "Ret indstillinger",
    preferences_text: 'Vælg "Gem indstillinger", hvis du accepterer brugen af cookies på vores hjemmeside. Du kan også ændre indstillingerne. Det valg, du foretager, er kun gyldigt for den enhed, du bruger i øjeblikket. Hvis du vil foretage det samme valg på dine andre enheder, skal du gentage valget på disse enheder. Enheder kan være pc, mobil eller tablet.',
    preferences: [
      {
        required: !0,
        title: "Nødvendige",
        text: "Disse cookies er nødvendige for at gjensidige.dk virker og kan derfor ikke fjernes. De sikrer, at vores webshop og selvbetjening fungerer og tilføjer samtidigt et lag af sikkerhed."
      },
      {
        id: "analytics",
        title: "Statistik",
        text: "Vi bruger disse cookies til at forstå, hvordan du anvender vores hjemmeside, så vi kan forbedre brugeroplevelsen og rette eventuelle fejl."
      },
      {
        id: "personalization",
        title: "Funktionelle",
        text: "Disse cookies gør det muligt at tilpasse indholdet og udseendet af gjensidige.dk baseret på fx om du besøger os fra en smartphone og er kunde hos os, så du møder det indhold, der er mest relevant for dig."
      },
      {
        id: "display_ads",
        title: "Markedsføring",
        text: "Disse cookies bruges til at spore besøgende på tværs af gjensidige.dk og andre hjemmesider, så du altid møder den mest relevante rådgivning og annoncering fra os via tredjeparts-cookies."
      }
    ]
  }
}, Ie = {
  cart: "Cart",
  close: "Close",
  code: "en",
  gotofront: "To front page",
  home: "To the frontpage",
  login: "Sign in",
  menu: "Menu",
  search: "Search",
  skip: "Skip to content",
  consent: {
    accept: "Accept cookies",
    close: "Close modal",
    edit: "Set cookie preferences",
    necessary: "Reject cookies",
    save: "Save preferences",
    text: "Some cookies are essential to make our website work securely. Others are used to gather data, remember your settings and improve our services. We also use cookies from third parties to deliver their content.",
    title: "We too make use of cookies",
    preferences_title: "Set your cookie preferences",
    preferences_text: "We make use of cookies to remember your preferences and improve our services. Tailor your experience for this device by accepting only some of our cookies.",
    preferences: [
      {
        title: "Necessary",
        text: "Some cookies are necessary to keep the site secure and functional. They cannot be rejected"
      },
      {
        id: "analytics",
        title: "Statistics",
        text: "We use cookie to understand how you're using the site, so that we can continuously improve your user experience and fix errors."
      },
      {
        id: "personalization",
        title: "Functionality",
        text: "These cookies ensure the content is relevant to you. They allow us to adjust our communication and adapt the design to your device."
      },
      {
        id: "display_ads",
        title: "Marketing",
        text: "Some cookies are used to trace users across the site and other websites, so that you always get the most relevant content through third party cookies."
      }
    ]
  }
}, fo = {
  cart: "Handlekurv",
  close: "Lukk",
  code: "nb",
  gotofront: "Til forside",
  home: "Til forsiden",
  login: "Logg inn",
  menu: "Meny",
  search: "Søk",
  skip: "Hopp til innhold",
  consent: {
    accept: "Godta informasjonskapsler",
    close: "Lukk modalvindu",
    edit: "Endre innstillinger",
    necessary: "Kun nødvendige",
    save: "Lagre innstillinger",
    text: 'For å gi deg en god opplevelse og sørge for at alt fungerer som det skal på nettsidene våre, bruker vi informasjonskapsler. På denne måten kan vi forbedre nettsidene og vise deg mer relevant innhold og markedsføring. Du kan alltid <a href="/personvern-og-sikkerhet/informasjonskapsler-cookies">endre valgene dine og lese mer om informasjonskapsler</a>.',
    title: "Vi bruker informasjonskapsler (cookies)",
    preferences_title: "Endre innstillinger",
    preferences_text: "Velg «Lagre innstillinger» om du godtar bruken av informasjonskapsler på nettsidene våre. Du kan også endre innstillingene. Valget du gjør er kun gjeldende for den enheten du bruker nå. Om du vil gjøre samme valg på de andre enhetene dine, må du gjenta valget på disse enhetene. Enheter kan være PC, mobil eller nettbrett.",
    preferences: [
      {
        required: !0,
        title: "Nødvendige",
        text: "Nettsiden vår trenger disse informasjonskapslene for å fungere ordentlig. De er alltid aktivert og sørger for eksempel for å sikre at nettbutikken vår og påloggede tjenester fungerer og er sikre."
      },
      {
        id: "analytics",
        title: "Statistikk",
        text: "Disse informasjonskapslene hjelper oss å forstå hvordan nettsidene våre brukes slik at vi kan forbedre opplevelsen og funksjonaliteten på sidene. Vi kan for eksempel bruke statistikk for å se hvor mange som besøker de ulike nettsidene våre."
      },
      {
        id: "personalization",
        title: "Brukeradferd og relevant innhold",
        text: "Disse informasjonskapslene brukes for å samle inn data på individnivå om hvordan du bruker nettsidene våre. Dataene kan vi bruke til blant annet å forbedre løsningene våre, gi deg tilpasset innhold på nettsidene og mer relevant markedsføring i andre kommunikasjonskanaler som for eksempel e-post dersom du er kunde hos oss."
      },
      {
        id: "display_ads",
        title: "Markedsføring",
        text: "Disse informasjonskapslene brukes for annonsering og målrettet markedsføring på andre nettsider enn gjensidige.no. Informasjonskapslene brukes til å forstå hva du er interessert i på våre nettsider for så å tilby mer relevant markedsføring på andres nettsider."
      }
    ]
  }
}, mo = {
  cart: "Varukorg",
  close: "Stäng",
  code: "sv",
  gotofront: "Till förstasidan",
  home: "Till framsidan",
  login: "Logga in",
  menu: "Meny",
  search: "Sök",
  skip: "Hoppa till innehållet",
  consent: {
    accept: "Jag godkänner",
    close: "Stäng modalt fönster",
    edit: "Avancerade inställningar",
    necessary: "Endast nödvändiga",
    save: "Spara val",
    text: "Vi använder cookies för att ge dig en bättre upplevelse. De säkerställer att du ser det mest relevanta innehållet och att vi kan förbättra upplevelsen på vår webbplats. Läs mer om cookies på gjensidige.se.",
    title: "Cookies",
    preferences_title: "Avancerade inställningar",
    preferences_text: 'Några cookies används till anonym statistik och andra sätts av tredjepartstjänster. Du kan välja vilka cookies du samtycker till genom att aktivera eller avaktivera typen av cookies och sedan klicka på "Spara val".',
    preferences: [
      {
        required: !0,
        title: "Nödvändiga",
        text: "Vår webbplats behöver dessa cookies för att fungera på rätt sätt. De är alltid aktiverade och ser t.ex. till att vår webbshop och inloggade tjänster fungerar och tillför samtidigt ett lager av säkerhet."
      },
      {
        id: "analytics",
        title: "Statistik",
        text: "Dessa cookies hjälper oss att förstå hur besökare använder vår webbplats, t.ex. vilka sidor du besöker, så att vi kan förbättra användarupplevelsen och rätta eventuella fel."
      },
      {
        id: "personalization",
        title: "Personligt anpassade",
        text: "Dessa cookies anpassar innehållet och utseendet på vår webbplats baserat på om du t.ex. besöker oss från en smartphone eller är kund hos oss, så att du möts av det innehåll som är mest relevant för dig."
      },
      {
        id: "display_ads",
        title: "Relevant marknadsföring",
        text: "Dessa cookies används i plattformar för annonsering och riktad marknadsföring. De används för att förstå besökares intressen för att erbjuda en mer relevant och personlig anpassad upplevelse. Detta innebär att du kan se annonser på webbplatser som tillhör tredjepart baserat på ditt beteende och vad du visar intresse för på vår webbplats."
      }
    ]
  }
}, ye = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  da: ho,
  en: Ie,
  nb: fo,
  sv: mo
}, Symbol.toStringTag, { value: "Module" })), vo = x(function({
  badge: n,
  children: t,
  className: s,
  cookieConsent: a = !0,
  homeUrl: o = "/",
  isLoggedIn: r = !0,
  language: l,
  systemMessages: c,
  systemMessagesFilter: h,
  skipId: d,
  tracking: m = !0,
  ...b
}, w) {
  const u = J(null), [v, g] = j(!1), _ = Xn("(max-width: 800px)");
  let y = ye[l.toLowerCase()];
  return y || (y = Ie, console.warn(
    `core-navigation could not start with language "${l}"
      - Please use one of: "${Object.keys(ye).join('", "')}"
      - Fallback to english enabled`
  )), Q(w, () => u.current), Yn(u), Qn(_ && v), no(_), /* @__PURE__ */ i(M.Provider, { value: y, children: /* @__PURE__ */ f(Ee.Provider, { value: _, children: [
    /* @__PURE__ */ i("a", { className: p.skip, href: `#${d}`, children: y.skip }),
    !a || /* @__PURE__ */ i(uo, {}),
    !c || /* @__PURE__ */ i(
      so,
      {
        messages: c,
        filter: h
      }
    ),
    /* @__PURE__ */ f(
      "nav",
      {
        ...b,
        className: k(
          p.nav,
          r && p.isLoggedIn,
          s
        ),
        "data-mobile": _,
        "data-open": v,
        onClick: eo(m),
        ref: u,
        children: [
          /* @__PURE__ */ i(
            z,
            {
              "aria-label": y.home,
              className: p.logo,
              "data-tracking": "logo",
              href: o,
              label: /* @__PURE__ */ i(po, {})
            }
          ),
          /* @__PURE__ */ i(
            z,
            {
              "aria-expanded": v,
              "aria-label": y.menu,
              badge: n,
              className: p.burger,
              "data-tracking": "mobilemenu",
              icon: /* @__PURE__ */ i("mark", {}),
              onClick: (L) => {
                L.preventDefault(), g(!v);
              }
            }
          ),
          /* @__PURE__ */ i("div", { className: p.space }),
          /* @__PURE__ */ i("div", { className: p.break }),
          t
        ]
      }
    )
  ] }) });
}), bo = Object.assign(vo, {
  isMobile: Ee,
  language: M,
  TrackingProvider: Be,
  Actions: (e) => /* @__PURE__ */ i("div", { ...e, className: k(p.actions, e.className) }),
  CMS: F(({ className: e }) => ({
    className: k(p.cms, e),
    classNameExpand: ""
  })),
  CTA: F(({ className: e }) => ({
    className: k(p.cta, e),
    icon: /* @__PURE__ */ i(ue, {})
  })),
  Cart: oo,
  Item: z,
  Search: F(({ className: e, label: n }) => {
    const t = $(M).search;
    return {
      "data-tracking": "",
      className: k(p.search, e),
      icon: /* @__PURE__ */ i($e, {}),
      label: n || t
    };
  }),
  User: F(({ className: e, label: n, icon: t }) => {
    const s = $(M).login;
    return {
      "data-tracking": n ? "Username" : "",
      // If custom label is passed, mask as "Username" to prevent user name in logs
      className: k(p.user, e),
      icon: t || /* @__PURE__ */ i(He, {}),
      label: /* @__PURE__ */ i("span", { className: p.truncate, children: n || s })
    };
  })
});
function F(e) {
  return function(t) {
    return /* @__PURE__ */ i(z, { ...t, ...e(t) });
  };
}
export {
  bo as Nav
};
//# sourceMappingURL=nav.js.map
